import { MainComponent } from "./components";
import { TableProvider } from "./providers";

export function WarehouseTransactionsPage() {
  return (
    <TableProvider>
      <MainComponent />
    </TableProvider>
  );
}
